import MultiSelectInput from '@repo/ui/multiselect-input'
import { useQuery } from '@tanstack/react-query'

import {
  getCountriesList,
  getCountriesListQueryKey
} from '../../../api/countries/get-countries-list'
import { getTransportMeans } from '../../../api/transport-means/get-transport-means'
import useTranslate from '../../../lib/hooks/use-translate'
import {
  TripStepTypeEnum,
  tripStepTypeMapping
} from '../../../lib/types/enums/trip-bookings/trip-step-type.enum'
import { getCountryLabel } from '../../../lib/types/models/country/country-list'
import { TripScheduleFilters } from '../../../lib/types/models/trips-schedule/trip-schedule'
import { getTranslatedName } from '../../../lib/utils/functions/translation.functions'

type Props = {
  filter?: TripScheduleFilters
  onFilterChange: (filter: TripScheduleFilters) => void
}

const TripsMonitoringFilter: React.FC<Props> = ({ filter, onFilterChange }) => {
  const { t, currentLanguage } = useTranslate()

  const { data: countryList } = useQuery({
    queryKey: getCountriesListQueryKey(),
    queryFn: () => getCountriesList()
  })

  const { data: transportMeans } = useQuery({
    queryKey: ['transport-means'],
    queryFn: () => getTransportMeans({ version: 'BASIC', sort: { name: 'asc' } })
  })

  return (
    <div className="flex flex-col gap-4 pt-2">
      <MultiSelectInput
        label="Pays de séjour"
        searchable
        variant="primary"
        options={countryList?.data.map((country) => ({
          label: getCountryLabel(currentLanguage, country) ?? '',
          value: country.key
        }))}
        selectedOptions={filter?.countries?.map((ctr) => ({
          label:
            getCountryLabel(
              currentLanguage,
              countryList?.data.find(({ key }) => filter.countries?.includes(key))
            ) ?? '',
          value: ctr
        }))}
        onChange={(countries) => onFilterChange({ ...filter, countries })}
      />

      <MultiSelectInput
        searchable
        selectedOptions={filter?.transportMeans?.map((tm) => ({
          label: getTranslatedName(transportMeans?.data.find((t) => getTranslatedName(t) === tm)),
          value: tm
        }))}
        variant="primary"
        onChange={(transportMeans) => onFilterChange({ ...filter, transportMeans })}
        options={
          transportMeans?.data.map((tm) => ({
            label: getTranslatedName(tm),
            value: getTranslatedName(tm)
          })) || []
        }
        label="Moyen de transport"
      />

      <MultiSelectInput
        variant="primary"
        label="Type de trajet"
        options={Object.values(TripStepTypeEnum).map((type) => ({
          label: t(tripStepTypeMapping[type].label),
          value: type
        }))}
        selectedOptions={filter?.directionalities?.map((tm) => ({
          label: t(tripStepTypeMapping[tm].label),
          value: tm
        }))}
        onChange={(directionalities) => onFilterChange({ ...filter, directionalities })}
      />
    </div>
  )
}

export default TripsMonitoringFilter
